<div class="heading-text" [style]="styles">
    <div class="offers-today">{{ text }}</div>
    <div class="gradient right"></div>
</div>